// Angular
import { ChangeDetectorRef, Component, HostBinding, Input, OnInit, ViewRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthService, Logout } from 'app/core/auth';
import { ErrorsService } from 'app/core/common/_services/errors.service';
import { AppState } from 'app/core/reducers';
import { LayoutUtilsService } from 'app/core/_base/crud/utils/layout-utils.service';
import { finalize } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  standalone: false,
    selector: 'kt-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
    // Public properties
    // type of error template to be used, accepted values; error-v1 | error-v2 | error-v3 | error-v4 | error-v5 | error-v6
    @Input() type = 'error-v1';
    // full background image
    @Input() image: string;
    // error code, some error types template has it
    @Input() code = '404';
    // error title
    @Input() title: string;
    // error subtitle, some error types template has it
    @Input() subtitle: string;
    // error descriptions
    @Input() desc = 'Oops! Something went wrong!';
    // return back button title
    @Input() return = 'Return back';
    // return errors
    @Input() errors: string;

    public descriptionErrors: any[];

    public webService: string;

    /**
     * Object with loader to handle spinners in the view,
     * according to wich petition was made
     */
    public loader: boolean;

    @HostBinding('class') classes = 'kt-grid kt-grid--ver kt-grid--root';

    constructor(
        private store: Store<AppState>,
        private authService: AuthService,
        private errorService: ErrorsService,
        private layoutUtilsService: LayoutUtilsService,
        private changeDetectorRef: ChangeDetectorRef,
		private router: Router,
    ) {}

    ngOnInit(): void {
        if (this.errors) {
            const auxException = JSON.parse(this.errors);
            this.descriptionErrors = auxException.errors;
            this.subtitle = (auxException.message) ? auxException.message : this.subtitle;
            this.webService = auxException.webService;
            localStorage.removeItem('existException');
        }
    }

    /**
     * Checks if theres a new change in the dom to be forced
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-03-20
     */
    public updateDOM() {
        if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
            this.changeDetectorRef.detectChanges();
        }
    }

    /**
     * Showing general message in alert/dialog window
     * @param message string to show
     */
     private showModalAlert(message: string, error = false) {
        const modalRef = this.layoutUtilsService.generalAlert();
        modalRef.componentInstance.data = message;
        if(error) {
            modalRef.componentInstance.hasError = true;
        }
    }

    /**
     * Log out
     */
    logout() {
        this.authService.logout(null, true)
            .subscribe(logoutDone => {
                if (logoutDone) {
                    this.store.dispatch(new Logout());
                }
            });
    }

    /**
     * Send email error
     */
     sendEmail() {
        this.loader = true;
		localStorage.removeItem('existException');
        const error = {
            "generalMessage": this.subtitle != undefined ? this.subtitle : "",
            "details": this.descriptionErrors != undefined ? this.descriptionErrors : [""],
            "webservice": this.webService != undefined ? this.webService :""
        }
        this.errorService.sendEmailError(error)
            .pipe(
                finalize(() => {
                    this.loader = false;
                    this.updateDOM();
                })
            )
            .subscribe(resp => {
                this.showModalAlert(resp);
            });
    }
async goHome()
	{
		localStorage.removeItem('existException');
		this.router.navigate(['/']);

	}

	async clearCache()
	{


		var theCookies = document.cookie.split(';');
for (var i = 1 ; i <= theCookies.length; i++) {
    var acookie = theCookies[i-1];
    var cookieArr = acookie.split('=');
    console.log(cookieArr[0]);
    document.cookie = cookieArr[0]+"=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

// Get cache storage and clear cache storage
window.caches.keys().then(function(names) {
    for (let name of names)
        window.caches.delete(name);
});

// // Get indexed db and delete indexed db
// const dbs = await window.indexedDB.databases()
// dbs.forEach(db => { window.indexedDB.deleteDatabase(db.name) })

// clear localStorage
window.localStorage.clear();

// clear sessionStorage
window.sessionStorage.clear();
this.router.navigate(['/']);
	}
}
